module.exports = __webpack_public_path__ + "img/logo.df879bc1.png";